import { render } from "./UserOverlay.vue?vue&type=template&id=1234573b&scoped=true"
import script from "./UserOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOverlay.vue?vue&type=script&setup=true&lang=js"

import "./UserOverlay.vue?vue&type=style&index=0&id=1234573b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1234573b"],['__file',"src/components/UI/overlay/UserOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1234573b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1234573b', __exports__)) {
    api.reload('1234573b', __exports__)
  }
  
  module.hot.accept("./UserOverlay.vue?vue&type=template&id=1234573b&scoped=true", () => {
    api.rerender('1234573b', render)
  })

}


export default __exports__